/*
 * Storefront dev mode for GraphQL calls, on the server and in the browser (documents/helpers/devMode.md). Added for
 * jument; shared by every site of this core. null for every visitor without the `_dev_mode` cookie.
 */
import { has_ssr } from "@core/helpers/render-type";
import { get_cookie_client } from "@core/helpers/client/cookie";
import { DEV_MODE_COOKIES } from "@core/helpers/dev-mode-rules";

// -> null | { token, site_id, api_url }
export const get_dev_mode = async () => {
	if (has_ssr()) {
		const { get_dev_mode_server } = require("@core/helpers/server/dev-mode");
		return await get_dev_mode_server();
	}
	// the browser calls the API itself; what it holds was checked by /apis/dev-mode when it was set
	const token = get_cookie_client(DEV_MODE_COOKIES.token);
	return token ? { token, site_id: get_cookie_client(DEV_MODE_COOKIES.site) || null, api_url: get_cookie_client(DEV_MODE_COOKIES.api_url) || null } : null;
};

// the request headers the backend reads (web-server, GraphQL/helpers/dev_mode.js)
export const dev_mode_headers = (dev_mode) => (dev_mode?.token
	? { "dev-mode": dev_mode.token, ...(dev_mode.site_id ? { "dev-site": dev_mode.site_id } : {}) }
	: {});
